module.exports = __webpack_public_path__ + "static/media/erecht24-schwarz-impressum-klein.3cb97b8c.png";